/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_New_WorkspaceInputs */

const en_home_new_workspace = /** @type {(inputs: Home_New_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a new workspace`)
};

const id_home_new_workspace = /** @type {(inputs: Home_New_WorkspaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat workspace baru`)
};

/**
* | output |
* | --- |
* | "Create a new workspace" |
*
* @param {Home_New_WorkspaceInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const home_new_workspace = /** @type {((inputs?: Home_New_WorkspaceInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_New_WorkspaceInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_new_workspace(inputs)
	return en_home_new_workspace(inputs)
});